import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, combineLatest } from 'rxjs';
import { KundeKortService } from '../../services/kunde-kort.service';
import { NotificationService } from '../../shared/notification.service';
import { AddContactPersonDialog, KundekortInfoPopup } from '../kunde-kort/kunde-kort-popup/kunde-kort-info-popup';

// Contact book: every contact person once, with the customers (kundekort)
// they are linked to. Editing a person here changes them on every customer.
@Component({
  selector: 'app-contact-book',
  templateUrl: './contact-book.component.html',
  styleUrls: ['./contact-book.component.css']
})
export class ContactBookComponent implements OnInit, OnDestroy {
  search = '';
  contacts: any[] = [];
  filtered: any[] = [];
  loading = true;

  private sub: Subscription;

  constructor(private kundeKortService: KundeKortService, private dialog: MatDialog, private notifier: NotificationService) { }

  ngOnInit() {
    this.sub = combineLatest([this.kundeKortService.getAllContacts$(), this.kundeKortService.getCustomers()])
      .subscribe(([contacts, customers]) => {
        const names: { [id: string]: string } = {};
        (customers as any[]).forEach(k => names[k.kundekortId] = k.name || '(unnamed)');
        this.contacts = (contacts as any[])
          .map(c => ({
            ...c,
            cards: (c.kundekortIds || []).map(id => ({ id, name: names[id] || id })),
          }))
          .sort((a, b) => String(a.name || '').trim().localeCompare(String(b.name || '').trim()));
        this.loading = false;
        this.filter();
      });
  }

  ngOnDestroy() { this.sub?.unsubscribe(); }

  filter() {
    const q = this.search.trim().toLowerCase();
    this.filtered = q
      ? this.contacts.filter(c => [c.name, c.email, c.phone, c.stilling, c.company, ...c.cards.map(k => k.name)]
          .some(v => String(v || '').toLowerCase().includes(q)))
      : this.contacts;
  }

  newContact() {
    this.dialog.open(AddContactPersonDialog, { width: '720px', maxWidth: '95vw', data: {} });
  }

  edit(c: any) {
    this.dialog.open(AddContactPersonDialog, { width: '720px', maxWidth: '95vw', data: { contact: c } });
  }

  openCard(id: string, event: Event) {
    event.stopPropagation();
    this.dialog.open(KundekortInfoPopup, { width: '95vw', maxWidth: '1440px', height: '92vh', data: { kundekortId: id } });
  }

  remove(c: any, event: Event) {
    event.stopPropagation();
    const where = c.cards.length ? ` It is linked to ${c.cards.map(k => k.name).join(', ')}.` : '';
    if (!confirm(`Delete "${c.name || c.email || 'contact'}" from the contact book?${where}`)) return;
    this.kundeKortService.deleteContact(c.dbid)
      .catch(() => this.notifier.showNotification('error', 'Could not delete the contact'));
  }
}
